/* ../lib/components/routes/Main.svelte generated by Svelte v3.18.2 */
import {
	SvelteComponent,
	check_outros,
	component_subscribe,
	create_component,
	destroy_component,
	detach,
	group_outros,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	set_store_value,
	space,
	transition_in,
	transition_out
} from "svelte/internal";

import { push } from "svelte-spa-router";
import { isOpen } from "../../states/help";
import { treeData } from "../../states/mock";
import { resetLastExecuted } from "../../utils/patterns";
import Header from "../parts/Header/Header";
import Help from "../parts/Help/Help";
import MockTree from "../parts/MockTree/MockTree";

function create_if_block(ctx) {
	let current;
	const help = new Help({});
	help.$on("overlayclick", /*overlayclick_handler*/ ctx[4]);

	return {
		c() {
			create_component(help.$$.fragment);
		},
		m(target, anchor) {
			mount_component(help, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(help.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(help.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(help, detaching);
		}
	};
}

function create_fragment(ctx) {
	let t0;
	let t1;
	let current;
	const header = new Header({});
	header.$on("helpclick", /*helpclick_handler*/ ctx[3]);
	let if_block = /*$isOpen*/ ctx[1] && create_if_block(ctx);

	const mocktree = new MockTree({
			props: { treeData: /*$treeData*/ ctx[0] }
		});

	mocktree.$on("actionclick", /*showMock*/ ctx[2]);

	return {
		c() {
			create_component(header.$$.fragment);
			t0 = space();
			if (if_block) if_block.c();
			t1 = space();
			create_component(mocktree.$$.fragment);
		},
		m(target, anchor) {
			mount_component(header, target, anchor);
			insert(target, t0, anchor);
			if (if_block) if_block.m(target, anchor);
			insert(target, t1, anchor);
			mount_component(mocktree, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*$isOpen*/ ctx[1]) {
				if (if_block) {
					if_block.p(ctx, dirty);
					transition_in(if_block, 1);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(t1.parentNode, t1);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}

			const mocktree_changes = {};
			if (dirty & /*$treeData*/ 1) mocktree_changes.treeData = /*$treeData*/ ctx[0];
			mocktree.$set(mocktree_changes);
		},
		i(local) {
			if (current) return;
			transition_in(header.$$.fragment, local);
			transition_in(if_block);
			transition_in(mocktree.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(header.$$.fragment, local);
			transition_out(if_block);
			transition_out(mocktree.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(header, detaching);
			if (detaching) detach(t0);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(t1);
			destroy_component(mocktree, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $treeData;
	let $isOpen;
	component_subscribe($$self, treeData, $$value => $$invalidate(0, $treeData = $$value));
	component_subscribe($$self, isOpen, $$value => $$invalidate(1, $isOpen = $$value));

	function showMock(e) {
		const { mockUrl, treeItem } = e.detail;
		resetLastExecuted($treeData);
		treeItem.lastExecuted = true;
		treeData.set($treeData);
		const viewInfo = { mockUrl, target: treeItem.target };
		const viewInfoJson = JSON.stringify(viewInfo);
		push("/" + viewInfoJson);
	}

	const helpclick_handler = () => set_store_value(isOpen, $isOpen = true);
	const overlayclick_handler = () => set_store_value(isOpen, $isOpen = false);
	return [$treeData, $isOpen, showMock, helpclick_handler, overlayclick_handler];
}

class Main extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Main;